import {
  DateFormattingService,
  MediaItem,
  RocheXXTranslationContext,
  SearchTrackingData,
  useComponentTracking,
} from '@repo/roche-xx-shared';
import { RocheUITeaser, RocheUITeaserLayout } from '@rocheglobal/roche-ui';
import React, { useContext } from 'react';
import { AvailableLanguages } from '../../../components/custom/available-languages';
import { trackSearchItemClickEvent } from '../../tracking';

export interface RocheNewsImporterListItemProps {
  item: Partial<MediaItem>;
  trackingData: SearchTrackingData;
  locale?: string;
}

export const RocheNewsImporterListItem = ({ item, trackingData, locale }: RocheNewsImporterListItemProps) => {
  const translations = useContext(RocheXXTranslationContext);
  const { path } = useComponentTracking();
  const availableLanguages = Object.keys(item.Title || {});
  return (
    <RocheUITeaser
      layout={RocheUITeaserLayout.VARIANT_C_WITHOUT_IMAGE}
      teaserTitle={item.localisedTitle}
      teaserOverline={
        item.ReleaseDateTime
          ? DateFormattingService.formatMediaItem(item as MediaItem, translations.translations)
          : undefined
      }
      teaserUrl={item.link}
      teaserOverlineElement={
        <AvailableLanguages
          useClickHandler={true}
          languages={availableLanguages}
          slug={`${item.path}/${item.Slug}`}
          locale={locale}
        />
      }
      onTeaserClick={(e) => trackSearchItemClickEvent(e, trackingData, item.localisedTitle, item.link, path)}
    />
  );
};
